var scope_0 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6ebea73c052508291e3c2967115d251c.js').default;
var scope_1 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d75258b5f490f23a94e9aeca58250ca9.js').default;
var scope_2 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    